import {delay} from '@logistics-frontend/utils'

import {ConfigTypeFromFetchFunction, FetchFunction} from '../types'

type RetryOptions = {
  retries: number
  delay: number
}

const DEFAULT_RETRY_OPTIONS: RetryOptions = {
  retries: 2,
  delay: 100,
}

export function createRetryMiddleware(options: Partial<RetryOptions>) {
  const _options = {...DEFAULT_RETRY_OPTIONS, ...options}

  return function withRetry<TReq = unknown, TRes = unknown, TExtraConfig extends Record<string, unknown> = {}>(
    fetchFunc: FetchFunction<TReq, TRes, TExtraConfig>,
  ) {
    return function enhancedFetch(config: ConfigTypeFromFetchFunction<typeof fetchFunc> & Partial<RetryOptions>) {
      const retries = config.retries ?? _options.retries
      const delayMs = config.delay ?? _options.delay

      const retry = (attempt: number = 0): ReturnType<FetchFunction<TReq, TRes, TExtraConfig>> => {
        return fetchFunc(config).catch(err => {
          if (attempt < retries) {
            return delay(delayMs).then(() => retry(attempt + 1))
          }

          throw err
        })
      }

      return retry()
    }
  }
}
